export default {
  common: {
    error: "Etwas ist schiefgelaufen",
    reload: "Neu laden",
    errorNotification: "Wir wurden benachrichtigt und werden es so schnell wie möglich beheben. Falls das Problem weiterhin besteht, bitte",
    contactUs: "kontaktieren Sie uns.",
    language: "Sprache",
    loading: "Lädt...",
    loadingText: "Lädt",
    save: "Speichern",
    savedSuccessfully: "Erfolgreich Gespeichert",
    saving: "Speichern...",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    add: "Hinzufügen",
    search: "Suchen",
    filter: "Filter",
    clear: "Löschen",
    preview: "Vorschau",
    default: "Standard: {{value}}",
    optional: "Optional",
    required: "Erforderlich",
    noData: "Keine Daten",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Standorte",
      cities: "Städte", 
      regions: "Regionen",
      countries: "Länder",
      showOnMap: "Auf Karte anzeigen",
      addLocation: "Standort hinzufügen"
    },
    welcome: {
      title: "Willkommen bei Locations So Super.",
      subtitle: "Wählen Sie einen Bereich aus der Navigation aus, um zu beginnen."
    }
  },

  // Cities section
  cities: {
    title: "Städte",
    resourceSingular: "Stadt",
    resourcePlural: "Städte",
    headings: {
      name: "Name",
      status: "Status",
      locations: "Standorte", 
      region: "Region",
      country: "Land"
    },
    breadcrumbs: {
      cities: "Städte"
    }
  },

  // Countries section  
  countries: {
    title: "Länder",
    resourceSingular: "Land", 
    resourcePlural: "Länder",
    headings: {
      name: "Name",
      status: "Status",
      locations: "Standorte",
      cities: "Städte",
      regions: "Regionen"
    },
    breadcrumbs: {
      countries: "Länder"
    }
  },

  // Regions section
  regions: {
    title: "Regionen",
    resourceSingular: "Region",
    resourcePlural: "Regionen", 
    headings: {
      name: "Name",
      status: "Status",
      locations: "Standorte",
      cities: "Städte",
      country: "Land"
    },
    breadcrumbs: {
      regions: "Regionen"
    }
  },

  // Map section
  map: {
    title: "Karte",
    breadcrumbs: {
      locations: "Standorte"
    }
  },

  // Import section
  import: {
    title: "CSV-Import",
    breadcrumbs: {
      locations: "Standorte"
    },
    new: {
      title: "Standorte per CSV importieren",
      description: "Laden Sie eine CSV-Beispielvorlage herunter, um ein Beispiel des erforderlichen Formats zu sehen",
      sampleTemplate: "CSV-Beispielvorlage",
      uploadAndContinue: "Hochladen und fortfahren",
      abortOnError: "Bei Fehler abbrechen",
      abortOnErrorHelp: "Falls ein Fehler auftritt, wird der Import abgebrochen, der Fehler angezeigt und keine Standorte werden importiert.",
      needHelp: "Brauchen Sie Hilfe beim Importieren von Standorten?"
    },
    show: {
      title: "CSV-Import",
      youCanLeavePage: "Sie können diese Seite verlassen",
      backgroundMessage: "Ihr Import läuft weiterhin im Hintergrund",
      importProgress: "Import-Fortschritt",
      imported: "Importiert",
      suffix: "Standorte",
      importLog: "Import-Protokoll",
      cancelImport: "Import abbrechen",
      cancelConfirmation: {
        title: "Import abbrechen",
        message: "Sind Sie sicher, dass Sie diesen Import-Job abbrechen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
        note: "Hinweis: Für laufende Jobs muss der Job abgeschlossen werden und wird dann sofort gelöscht.",
        yesCancel: "Ja, Import abbrechen",
        noContinue: "Nein, Import fortsetzen"
      },
      report: "Bericht",
      failedLocations: "Fehlgeschlagene Standorte",
      uploadAnother: "Weitere CSV hochladen",
      backToLocations: "Zurück zu Standorten",
      importSucceeded: "Import erfolgreich",
      importFailed: "Import fehlgeschlagen"
    },
    messages: {
      uploadSuccess: "CSV erfolgreich hochgeladen",
      uploadError: "CSV konnte nicht hochgeladen werden",
      pending: "Import hat noch nicht begonnen",
      inProgress: "Import läuft",
      completed: "Import abgeschlossen",
      invalidHeader: "Die folgenden Spalten sind erforderlich",
      invalidCsvFile: "Ungültige CSV-Datei",
      aborted: "Import abgebrochen",
      failed: "Import fehlgeschlagen",
      cancelled: "Import abgebrochen"
    },
    errors: {
      csvTooLarge: "CSV ist zu groß",
      languageNotEnabled: "Sprache '{{language}}' ist für diesen Shop nicht aktiviert. Bitte aktivieren Sie sie zuerst in Einstellungen > Sprachen.",
      fieldNotTranslatable: "Feld '{{field}}' ist nicht übersetzbar. Übersetzbare Felder sind: {{fields}}",
      locationError: "Standort mit Slug: {{slug}} - {{error}}",
      planLimit: "Sie haben das Limit Ihres Plans für Standorte erreicht"
    }
  },

  // Location form
  location: {
    index: {
      title: "Standorte",
      addLocation: "Standort hinzufügen",
      import: "Importieren",
      noPrioritySet: "Keine Priorität gesetzt",
      published: "Veröffentlicht",
      draft: "Entwurf",
      resourceSingular: "Standort",
      resourcePlural: "Standorte",
      headings: {
        name: "Name",
        status: "Status", 
        city: "Stadt",
        region: "Region",
        country: "Land",
        priority: "Priorität"
      }
    },
    form: {
      title: "Standort hinzufügen",
      editTitle: "Standort bearbeiten",
      basicInformation: "Grundinformationen",
      name: "Name",
      namePlaceholder: "z.B. Brians Ziegel",
      nameHelpDefault: "Standard: {{defaultName}}",
      details: "Details",
      description: "Beschreibung",
      descriptionPlaceholder: "Erzählen Sie Kunden, was diesen Standort besonders macht",
      address: "Adresse",
      addressPlaceholder: "123 Hauptstraße, Stadt, Land",
      addressLine1: "Adresszeile 1",
      addressLine2: "Adresszeile 2",
      postalZipCode: "Postleitzahl / PLZ",
      city: "Stadt",
      stateProvinceRegion: "Bundesland / Provinz / Region",
      country: "Land",
      phone: "Telefon",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "E-Mail", 
      emailPlaceholder: "shop@beispiel.com",
      website: "Website",
      websitePlaceholder: "https://www.beispiel.com",
      image: "Bild",
      imagePlaceholder: "Bild-URL eingeben",
      status: "Status",
      statusActive: "Aktiv",
      statusInactive: "Inaktiv",
      statusDraft: "Entwurf",
      priority: "Priorität",
      priorityHelpText: "Standorte mit höherer Priorität erscheinen zuerst in den Suchergebnissen",
      findOnMapButton: "Auf Karte finden"
    },
    validation: {
      addressNotFound: "Adresse konnte nicht gefunden werden",
      createSuccess: "Standort erfolgreich erstellt", 
      updateSuccess: "Standort erfolgreich aktualisiert",
      checkFields: "Bitte überprüfen Sie Ihre Felder",
      findOnMap: "Bitte finden Sie Ihren Standort auf der Karte, bevor Sie speichern"
    },
    errors: {
      loading: "Fehler beim Laden des Standorts"
    },
    actions: {
      save: "Standort speichern",
      delete: "Standort löschen",
      preview: "Vorschau"
    },
    customFields: {
      title: "Benutzerdefinierte Felder",
      noCustomFields: "Keine benutzerdefinierten Felder konfiguriert",
      configureFields: "Felder konfigurieren",
      emptyState: "Sie haben noch keine benutzerdefinierten Felder konfiguriert. Benutzerdefinierte Felder ermöglichen es Ihnen, zusätzliche Informationen hinzuzufügen, die spezifisch für Ihre Geschäftsanforderungen sind."
    },
    openingHours: {
      title: "Öffnungszeiten",
      checkboxLabel: "Dieser Standort hat Öffnungs- und Schließzeiten",
      statusOpen: "Geöffnet",
      statusOpen24h: "24h geöffnet",
      statusClosed: "Geschlossen",
      openingTimeLabel: "Öffnungszeit",
      closingTimeLabel: "Schließzeit",
      days: {
        monday: "Montag",
        tuesday: "Dienstag", 
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Kürzlich hinzugefügt",
        recentlyModified: "Kürzlich geändert"
      },
      filters: {
        status: "Status",
        taggedWith: "Markiert mit",
        locationStatus: "Standortstatus",
        noTagsToShow: "Keine Tags zum Anzeigen",
        searchPlaceholder: "Suchen"
      },
      bulkActions: {
        setPublished: "Als veröffentlicht markieren",
        setUnpublished: "Als unveröffentlicht markieren", 
        setPriority: "Priorität setzen",
        deleteLocations: "Standorte löschen",
        exportCSV: "Als CSV exportieren"
      },
      appliedFilters: {
        statusIs: "Status ist {{status}}",
        taggedWith: "Markiert mit {{tag}}",
        nameIncludes: "Name enthält {{search}}"
      },
      modals: {
        deleteTitle: "Standorte löschen",
        deleteMessage: "Sind Sie sicher, dass Sie {{count}} löschen möchten?",
        deleteMessageAll: "Sind Sie sicher, dass Sie alle Standorte löschen möchten?",
        prioritiseTitle: "{{count}} Standorte priorisieren",
        prioritiseTitleAll: "Alle Standorte priorisieren",
        delete: "Löschen",
        cancel: "Abbrechen"
      },
      emptyState: {
        noResultsHeading: "Keine {{resourcePlural}} gefunden",
        noResultsText: "Versuchen Sie, die Filter oder Suchbegriffe zu ändern",
        noDataHeading: "Fügen Sie einen Standort hinzu, um {{resourcePlural}} zu füllen",
        addLocation: "Standort hinzufügen",
        importFromCSV: "Aus CSV importieren"
      },
      pagination: {
        label: "Seite {{page}} von {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Erfolgreich aktualisiert",
        deletedSuccessfully: "Erfolgreich gelöscht", 
        exportedSuccessfully: "Erfolgreich exportiert",
        error: "Etwas ist schiefgelaufen"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Seiteninhalt",
    editTemplate: "SEO-Vorlage bearbeiten", 
    pageTitle: "Titel",
    pageDescription: "Beschreibung",
    metaTitle: "Titel",
    metaDescription: "Beschreibung",
    urlHandle: "URL-Handle",
    searchEnginePreview: "Suchmaschinen-Listenvorschau",
    editMeta: "Meta bearbeiten",
    previewMeta: "Meta-Vorschau",
    loading: "Lädt...",
    editingLocaleHelp: "Bearbeite {{locale}}-Inhalt."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-Vorlagen",
    breadcrumbs: {
      seoTemplates: "SEO-Vorlagen"
    },
    template: {
      title: "{{templateName}}-Vorlage - {{locale}}",
      discardChanges: "Änderungen verwerfen"
    },
    form: {
      pageContent: "Seiteninhalt",
      searchEnginePreview: "Suchmaschinen-Listenvorschau",
      title: "Titel",
      description: "Beschreibung",
      pageTitle: "Seitentitel",
      metaDescription: "Meta-Beschreibung",
      editingLocaleHelp: "Bearbeite {{locale}}-Übersetzungen. Leere Felder zeigen Inhalt von {{defaultLocale}} an.",
      defaultValue: "Standard: {{value}}"
    },
    language: {
      label: "Sprache",
      defaultHelp: "Dies ist Ihre Standardsprache",
      editingHelp: "Bearbeite {{locale}}-Übersetzungen. Leere Felder zeigen {{defaultLocale}}-Inhalt an."
    },
    banner: {
      multipleLanguagesDisabled: "Mehrsprachigkeit nicht aktiviert",
      enableInSettings: "In Einstellungen aktivieren",
      multipleLanguagesInfo: "Um SEO-Vorlagen für mehrere Sprachen zu verwalten, aktivieren Sie die Internationalisierung in Ihren Spracheinstellungen. Derzeit werden nur {{locale}}-Vorlagen angezeigt."
    },
    badges: {
      errors: "Fehler!",
      unsaved: "Nicht gespeichert"
    },
    messages: {
      saveSuccess: "SEO-Vorlagen erfolgreich gespeichert",
      saveError: "Vorlagen konnten nicht gespeichert werden",
      error: "Fehler..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Grundinformationen",
      name: "Name",
      save: "Speichern",
      saving: "Speichern...",
      cancel: "Abbrechen",
      yourLocationsIn: "Ihre Standorte in {{name}}",
      tableHeadings: {
        name: "Name",
        status: "Status",
        city: "Stadt",
        region: "Region",
        country: "Land"
      },
      resourceName: {
        singular: "{{name}}-Standort",
        plural: "Standorte in {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Karte",
      tags: "Tags",
      customFields: "Benutzerdefinierte Felder",
      languages: "Sprachen",
      plan: "Plan",
      addTag: "Tag hinzufügen",
      addField: "Feld hinzufügen"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Endet bald"
    },
    common: {
      loading: "Lädt...",
      error: "Fehler...",
      breadcrumbs: {
        settings: "Einstellungen"
      },
      skeleton: {
        customFields: "Benutzerdefinierte Felder",
        addField: "Feld hinzufügen",
        name: "Name",
        contentType: "Inhaltstyp",
        usedIn: "Verwendet in",
        field: "Feld",
        fields: "Felder"
      },
      messages: {
        savedSuccessfully: "{{setting}}-Einstellungen erfolgreich gespeichert",
        couldntSave: "{{setting}}-Einstellungen konnten nicht gespeichert werden"
      }
    },
    map: {
      title: "Karte",
      messages: {
        savedSuccessfully: "Karteneinstellungen erfolgreich gespeichert",
        couldntSave: "Einstellungen konnten nicht gespeichert werden"
      },
      mapboxToken: {
        title: "Mapbox-Token",
        description: "Geben Sie Ihren Mapbox-Token ein, um Ihren Store Locator zu betreiben",
        label: "Mapbox-Token",
        placeholder: "Geben Sie hier den Token ein, um Ihre Karte weiterhin zu nutzen.",
        placeholderManaged: "Geben Sie hier den Token ein, um Ihre Karte weiterhin zu nutzen, sobald Sie keine kostenlosen Kartenladungen mehr haben.",
        helpText: "Folgen Sie unseren Anweisungen zum Erstellen eines Mapbox-Schlüssels und fügen Sie dann Ihren Schlüssel oben ein. Falls Sie auf Probleme stoßen, kontaktieren Sie uns bitte für Unterstützung.",
        linkInstructions: "Anweisungen zum Erstellen eines Mapbox-Schlüssels",
        linkSupport: "kontaktieren Sie uns für Unterstützung"
      },
      managedToken: {
        title: "Kartenladungen",
        description: "Sie haben bis zu {{max}} kostenlose Kartenladungen mit einem verwalteten Token, danach müssen Sie Ihren eigenen Token erstellen."
      },
      appearance: {
        title: "Erscheinungsbild",
        description: "Ändern Sie das Aussehen Ihrer Karte"
      },
      mapStyle: {
        title: "Kartenstil",
        options: {
          streets: "Straßen",
          outdoors: "Outdoor", 
          light: "Hell",
          dark: "Dunkel",
          satellite: "Satellit",
          satelliteStreets: "Satellitenstraßen",
          navigationDay: "Navigation Tag",
          navigationNight: "Navigation Nacht"
        }
      },
      searchBehaviour: {
        title: "Suchverhalten",
        description: "Steuert, wie Besucher Standorte auf Ihrer Karte finden.",
        geolocateLabel: "Automatisch den Standort des Besuchers schätzen und nahegelegene Geschäfte anzeigen",
        geolocateHelp: "Falls die Geolokalisierung erfolgreich ist, bewegt sich die Karte, um sich auf die Nähe des Besuchers zu konzentrieren. Falls kein geschätzter Standort gefunden werden kann, bleibt die Karte in der Ausgangsposition.",
        filterBehaviour: {
          title: "Filterverhalten",
          all: {
            label: "Alle Tags",
            help: "Damit ein Standort in Filtern angezeigt wird, muss er alle ausgewählten Tags haben"
          },
          any: {
            label: "Beliebige Tags", 
            help: "Damit ein Standort in Filtern angezeigt wird, kann er beliebige der ausgewählten Tags haben"
          }
        },
        keepSearchInView: {
          label: "Suchmarkierung im Blick behalten",
          help: "Wenn Suchergebnisse erscheinen, zoomt die Karte heraus, um alle passenden Standorte anzuzeigen"
        },
        distanceUnits: {
          title: "Entfernungseinheiten",
          km: "Kilometer",
          miles: "Meilen"
        },
        maxResults: {
          label: "Max. Ergebnisse",
          help: "Begrenzen Sie die Anzahl der in Suchergebnissen angezeigten Standorte",
          options: {
            results30: "30 Ergebnisse"
          }
        },
        maxDistance: {
          label: "Max. Entfernung", 
          help: "Zeigen Sie nur Standorte innerhalb dieser Entfernung vom Suchpunkt an",
          options: {
            unlimited: "Unbegrenzt"
          }
        },
        showLocationNames: {
          label: "Standortnamen in Vorschlägen anzeigen",
          help: "Standortnamen in Suchvorschlägen anzeigen"
        },
        sortByPriority: {
          label: "Nach Priorität statt nach Entfernung sortieren",
          help: "Es wird dringend empfohlen, eine maximale Entfernung (die nicht unbegrenzt ist) zu setzen, wenn dieses Kästchen aktiviert ist. Andernfalls sehen Ihre Kunden weit entfernte Standorte mit hoher Priorität über denen aufgelistet, die sich in einer angemessenen Entfernung von ihnen befinden (oder genauer gesagt, von ihrer Suchanfrage)."
        }
      },
      searchResults: {
        title: "Suchergebnisse",
        description: "Steuert, wie Standorte auf Ihrer Karte zurückgegeben werden.",
        locationsLabel: "Suchergebnisse-Text",
        locationsHelp: "Text, der über Suchergebnissen angezeigt wird (z.B. 'Zeige 5 Standorte')",
        prefixLabel: "Suchergebnisse-Präfix", 
        prefixHelp: "Text, der vor der Anzahl der Ergebnisse angezeigt wird"
      },
      popups: {
        title: "Popups",
        showPopups: {
          label: "Popups anzeigen",
          help: "Standortdetails anzeigen, wenn Besucher auf Kartenmarkierungen klicken"
        }
      },
      whitelabel: {
        title: "Whitelabel",
        hideLabel: "Powered by-Text ausblenden",
        hideHelp: "Entfernen Sie unser Branding aus Ihrem Store Locator"
      }
    },
    languages: {
      title: "Sprachen",
      error: "Fehler...",
      messages: {
        savedSuccessfully: "Spracheinstellungen erfolgreich gespeichert",
        couldntSave: "Spracheinstellungen konnten nicht gespeichert werden"
      },
      banner: {
        upgradeTitle: "Mehrsprachige Unterstützung erfordert Plan-Upgrade",
        upgradeAction: "Zu Superest upgraden",
        upgradeMessage: "Sie können Ihre Standardsprache weiterhin ändern, aber die Aktivierung mehrerer Sprachen erfordert ein Upgrade.",
        disabledMessage: "Mehrsprachige Einstellungen sind in Ihrem aktuellen Plan deaktiviert"
      },
      defaultLanguage: {
        title: "Standardsprache", 
        description: "Wählen Sie Ihre primäre Sprache aus, in der Ihr Inhalt angezeigt wird.",
        label: "Standardsprache",
        help: "Diese Sprache wird verwendet, wenn keine spezifische Sprache angefordert wird"
      },
      internationalization: {
        title: "Internationalisierung",
        description: "Aktivieren Sie mehrere Sprachen. Erreichen Sie mehr Kunden und steigern Sie Ihr SEO.",
        enableLabel: "Mehrere Sprachen aktivieren",
        enableHelp: "Erlauben Sie Kunden, Ihren Store Locator in verschiedenen Sprachen zu sehen"
      },
      supportedLanguages: {
        title: "Zusätzlich unterstützte Sprachen",
        description: "Wählen Sie zusätzliche Sprachen aus, die Sie unterstützen möchten. Sobald Sie eine Sprache aktiviert haben, sehen Sie die Option, Übersetzungen in der gesamten App bereitzustellen. Für unterstützte Sprachen werden die Standard-SEO-Vorlagen sowie die gemeinsamen variablen Themes automatisch generiert.",
        defaultLocaleNote: "Dies ist Ihre Standardsprache und kann nicht deaktiviert werden",
        shopifyEnabled: {
          label: "Diese Sprache ist in meinem Shopify-Shop aktiviert",
          importantNote: "Wichtig:",
          description: "Deaktivieren Sie das obige Kästchen, wenn diese Sprache nicht aktiviert und für Ihren Shopify-Shop veröffentlicht ist. Es wird empfohlen, die Sprache für Ihren Shopify-Shop zuerst zu aktivieren, indem Sie zu Einstellungen > Sprachen in Ihrem Shopify-Admin gehen, falls Sie es noch nicht getan haben, für eine bessere Kundenerfahrung."
        },
        urlFormats: {
          cleanUrls: "Saubere URLs:",
          betterSeo: "Besseres SEO und Benutzererfahrung",
          queryUrls: "Query-Parameter-URLs:",
          considerEnabling: "Erwägen Sie die Aktivierung in Shopify für bessere URLs"
        },
        preview: {
          button: "Vorschau",
          tooltip: "{{language}}-Store Locator-Vorschau"
        },
        tooltips: {
          noTemplates: "Keine Standard-SEO-Vorlagen für diese Sprache verfügbar. Sie können benutzerdefinierte Übersetzungen einfach erstellen."
        }
      }
    },
    tags: {
      title: "Tags",
      addTag: "Tag hinzufügen",
      error: "Fehler",
      messages: {
        deletedSuccessfully: "Tags erfolgreich gelöscht",
        couldntDelete: "Tags konnten nicht gelöscht werden",
        savedSuccessfully: "Tag erfolgreich gespeichert",
        couldntSave: "Bitte überprüfen Sie Ihre Felder",
        tagDeleted: "Tag erfolgreich gelöscht"
      },
      resourceName: {
        singular: "Tag",
        plural: "Tags"
      },
      filters: {
        anyGroup: "Beliebige Gruppe",
        inGroup: "In Gruppe",
        tagGroup: "Tag-Gruppe"
      },
      appliedFilters: {
        inGroup: "In {{group}}-Gruppe",
        nameContains: "Tag-Name enthält {{query}}"
      },
      bulkActions: {
        deleteTag: "Tag löschen",
        deleteTags: "Tags löschen"
      },
      form: {
        language: "Sprache",
        title: "Titel",
        description: "Beschreibung",
        group: "Gruppe",
        groupPlaceholder: "Gruppe auswählen",
        addGroup: "Hinzufügen",
        editingTranslations: "Bearbeite {{language}}-Übersetzungen. Leere Felder zeigen Inhalt von {{defaultLanguage}} an.",
        defaultValue: "Standard: {{value}}",
        image: "Bild",
        imageUrl: "Bild-URL"
      },
      actions: {
        save: "Speichern",
        deleteTag: "Tag löschen"
      },
      new: {
        title: "Tag hinzufügen",
        messages: {
          createSuccess: "Tag erfolgreich erstellt",
          checkFields: "Bitte überprüfen Sie Ihre Felder"
        },
        actions: {
          createTag: "Tag erstellen"
        }
      }
    },
    customFields: {
      title: "Benutzerdefinierte Felder",
      addField: "Feld hinzufügen",
      error: "Fehler",
      resourceName: {
        singular: "Feld",
        plural: "Felder"
      },
      headings: {
        name: "Name",
        contentType: "Inhaltstyp",
        usedIn: "Verwendet in"
      },
      emptyState: {
        heading: "Erstellen und verwalten Sie Ihre benutzerdefinierten Felder",
        createAction: "Feld erstellen",
        description: "Verwenden Sie benutzerdefinierte Felder für eindeutige Attribute zu Ihren Standorten. Diese Felder können alles sein, von sozialen Profilen bis hin zum Namen und der E-Mail des Geschäftsleiters"
      },
      pluralization: {
        location: "Standort",
        locations: "Standorte"
      },
      form: {
        name: "Name",
        contentType: "Inhaltstyp",
        key: "Schlüssel",
        keyPrefix: "location.fields.",
        keyHelp: "Verwenden Sie diesen Schlüssel, um auf den {{name}}-Inhalt eines Standorts in Ihren Liquid-Vorlagen zuzugreifen.",
        translations: {
          title: "Übersetzungen",
          showTranslations: "Übersetzungen anzeigen",
          hideTranslations: "Übersetzungen ausblenden",
          description: "Übersetzungen sind optional. Leere Felder zeigen den {{language}}-Feldnamen an.",
          nameTranslation: "Name ({{language}})",
          defaultValue: "Standard: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Feld erfolgreich gespeichert",
        couldntSave: "Feld konnte nicht gespeichert werden",
        deletedSuccessfully: "Feld erfolgreich gelöscht",
        couldntDelete: "Feld konnte nicht gelöscht werden"
      },
      actions: {
        delete: "Löschen"
      },
      new: {
        title: "Feld hinzufügen",
        messages: {
          savedSuccessfully: "Feld erfolgreich gespeichert",
          couldntSave: "Feld konnte nicht gespeichert werden"
        }
      },
      contentTypes: {
        text: "Text",
        textArea: "Textbereich", 
        email: "E-Mail",
        number: "Nummer",
        phoneNumber: "Telefonnummer",
        time: "Zeit",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Fehler",
      changePlan: "Plan ändern",
      usdPerMonth: "USD / Monat",
      sections: {
        yourPlanIncludes: "Ihr Plan beinhaltet",
        nextBillingDate: "Nächster Abrechnungstermin",
        trial: "Testversion"
      },
      banners: {
        planUpdated: "Ihr Plan wurde aktualisiert",
        thankYouUpgrading: "Vielen Dank für das Upgrade!",
        letUsKnow: "Lassen Sie es uns wissen",
        improvementText: "falls es etwas gibt, was wir besser machen können.",
        trialCancellation: {
          title: "Hinweis zur Testversion-Kündigung",
          message: "Ihre 14-tägige kostenlose Testversion wird gekündigt, sobald Sie auf einen kostenpflichtigen Plan upgraden."
        }
      },
      locations: {
        upTo: "Bis zu",
        locations: "Standorte",
        unlimited: "Unbegrenzte Standorte",
        used: "verwendet",
        ofUsed: "{{used}} von {{max}} verwendet"
      },
      trial: {
        daysLeft: "{{days}} Tage übrig",
        daysUsed: "{{used}} von {{total}} Tagen verwendet",
        selectPlan: "Plan auswählen",
        currentPlan: "Aktueller Plan",
        trialBadge: "Testversion",
        currentBadge: "Aktuell",
        yourTrialJustStarted: "Ihre Testversion hat gerade begonnen",
        trialEndsAfterToday: "Ihre Testversion endet nach heute",
        trialEndsTomorrow: "Ihre Testversion endet morgen",
        daysLeftInTrial: "{{days}} Tage übrig in Ihrer Testversion",
        continueAddingLocations: "Fügen Sie nach {{date}} weiterhin Standorte hinzu, indem Sie einen Plan auswählen",
        selectPlanToday: "Bitte wählen Sie heute einen Plan aus, um weiterhin Standorte hinzuzufügen"
      },
      footer: {
        description: "Verwalten oder ändern Sie Ihren Locations So Super Plan. Sehen Sie unsere",
        termsOfService: "Nutzungsbedingungen",
        and: "und",
        privacyPolicy: "Datenschutzrichtlinie"
      },
      features: {
        analytics: {
          title: "Analytics",
          description: "Finden Sie heraus, wie Menschen Ihre Standorte nutzen und wo sie suchen"
        },
        internationalization: {
          title: "Mehrsprachige Unterstützung",
          description: "Steigern Sie SEO und erreichen Sie mehr Kunden in Zielmärkten durch die Aktivierung mehrerer Sprachen"
        },
        customThemes: {
          editLiquid: {
            title: "Theme-Liquid-Vorlagen bearbeiten",
            description: "Zeigen Sie Standortdaten in beliebiger Weise an mit Zugriff auf Theme-Liquid"
          },
          editStructuredData: {
            title: "Geschäftsstrukturierte Daten bearbeiten",
            description: "Bearbeiten Sie, wie Google Seiten versteht, indem Sie Ihre strukturierten Daten bearbeiten"
          }
        }
      },
      edit: {
        title: "Plan ändern",
        allPlansInclude: "Alle Pläne oben beinhalten",
        needingMoreLocations: "Brauchen Sie mehr Standorte?",
        footerQuestion: "Haben Sie Fragen, bevor Sie beginnen?",
        sendMessage: "senden Sie uns eine Nachricht",
        allFeatures: {
          seoDirectory: {
            title: "SEO-Verzeichnis und Landing Pages",
            description: "Erstellen Sie automatisch ein SEO-Verzeichnis aller Ihrer Standorte, Städte und Regionen"
          },
          mapPage: {
            title: "Kartenseite mit Suche und Filter",
            description: "Suchen und filtern Sie alle Ihre Standorte mit einer von Mapbox betriebenen Karte"
          },
          tags: {
            title: "Tags",
            description: "Erstellen Sie Tags mit Bildern und Beschreibungen und gruppieren Sie sie"
          },
          openingHours: {
            title: "Öffnungszeiten",
            description: "Setzen und zeigen Sie die Öffnungszeiten für Ihre Standorte an"
          },
          mapStyles: {
            title: "Kartenstile",
            description: "Ändern Sie das Aussehen der Karten mit einer Reihe von voreingestellten Stilen"
          },
          customFields: {
            title: "Benutzerdefinierte Felder",
            description: "Fügen Sie beliebige neue Felder hinzu, von sozialen Links bis hin zum Geschäftsleiter"
          },
          csvUpload: {
            title: "Upload und Export mit CSV",
            description: "Laden Sie Ihre Standorte hoch und bearbeiten Sie sie in großen Mengen."
          },
          richSnippets: {
            title: "Rich Snippets",
            description: "Helfen Sie Google, Seiten besser zu verstehen mit strukturierten Daten für lokale Geschäfte"
          },
          directionsAndCalls: {
            title: "Wegbeschreibung und Anrufe",
            description: "Besucher können leicht Wegbeschreibungen erhalten und Anrufe zu den Standorten tätigen"
          },
          languageSupport: {
            title: "Sprachunterstützung",
            description: "Ändern Sie die Standardsprache zu etwas anderem als Englisch. Übersetzungsvorlagen für 32 Hauptsprachen für einfache Einrichtung bereitgestellt."
          }
        }
      },
      planCard: {
        bestToCustomize: "Am besten zum Anpassen",
        currentPlan: "Aktueller Plan",
        chooseThisPlan: "Diesen Plan wählen",
        locationsSection: "Standorte",
        featuresSection: "Funktionen",
        upTo: "Bis zu",
        locations: "Standorte",
        tooltipTooManyLocations: "Sie haben zu viele Standorte und/oder aktivierte Sprachen für diesen Plan."
      },
      confirmation: {
        error: "Fehler beim Bestätigen des Plans"
      }
    }
  },

  // Themes section
  themes: {
    title: "Themes",
    currentTheme: {
      title: "Aktuelles Theme",
      description: "Dies ist das Theme, das Kunden sehen, wenn sie Ihre Standort-App besuchen."
    },
    themeLibrary: {
      title: "Theme-Bibliothek", 
      description: "Verwalten Sie Ihre Standort-Themes. Fügen Sie Themes hinzu und veröffentlichen Sie sie, um das Aussehen Ihres Online-Standorts zu ändern."
    },
    skeleton: {
      currentThemeDescription: "Dies ist das Theme, das Ihre Kunden sehen, wenn sie Ihre Standort-App verwenden."
    },
    modal: {
      overrideTitle: "Aktuelles Theme überschreiben?",
      override: "Überschreiben",
      cancel: "Abbrechen",
      undoWarning: "Diese Aktion kann nicht rückgängig gemacht werden."
    },
    messages: {
      publishSuccess: "Theme erfolgreich veröffentlicht",
      publishError: "Theme konnte nicht veröffentlicht werden",
      error: "Etwas ist schiefgelaufen"
    },
    emptyStates: {
      settings: {
        heading: "Dieses Theme hat keine Einstellungen",
        description: "Erstellen Sie Einstellungen im Template-Editor.",
        createSettings: "Einstellungen erstellen",
        upgradePlan: "Plan upgraden",
        upgradeRequired: "Plan upgraden, um Einstellungen zu erstellen"
      },
      language: {
        heading: "Dieses Theme hat keine Sprachbegriffe",
        description: "Erstellen Sie Sprachbegriffe im Template-Editor.",
        createLanguageTerms: "Sprachbegriffe erstellen",
        upgradePlan: "Plan upgraden",
        upgradeRequired: "Plan upgraden, um Sprachbegriffe zu erstellen"
      }
    },
    templates: {
      categories: {
        templates: "Vorlagen",
        schemas: "Schemas",
        styles: "Stile",
        liquidReference: "Liquid-Referenz"
      },
      items: {
        landing: "Landing",
        directory: "Verzeichnis",
        country: "Land",
        region: "Region",
        city: "Stadt",
        location: "Standort",
        language: "Sprache",
        settings: "Einstellungen",
        stylesheet: "Stylesheet"
      },
      errors: {
        errorsInTemplate: "Fehler in Vorlage",
        error: "Fehler"
      },
      badges: {
        errors: "Fehler!",
        unsaved: "Nicht gespeichert"
      },
      actions: {
        viewTheme: "Theme anzeigen",
        discard: "Verwerfen",
        save: "Speichern"
      }
    },
    language: {
      messages: {
        saveSuccess: "Theme-Sprachübersetzungen erfolgreich gespeichert",
        saveError: "Theme konnte nicht gespeichert werden"
      },
      form: {
        language: "Sprache",
        defaultLanguageHelp: "Dies ist Ihre Standardsprache",
        translationHelp: "Bearbeite Übersetzungen für {{selectedLocale}}. Leere Felder zeigen Inhalt von {{defaultLocale}} (Ihrer Standardsprache) an."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Mehrere Sprachen nicht aktiviert",
          action: "In Einstellungen aktivieren",
          description: "Um Übersetzungen für mehrere Sprachen zu verwalten, aktivieren Sie die Internationalisierung in Ihren Spracheinstellungen. Derzeit werden nur {{locale}}-Übersetzungen angezeigt."
        },
        translating: {
          title: "Übersetzen von {{from}} nach {{to}}",
          description: "Jedes Feld, das Sie leer lassen, zeigt automatisch den {{defaultLocale}}-Inhalt Ihren Kunden an. Übersetzen Sie nur die Felder, in denen Sie anderen Inhalt in {{selectedLocale}} möchten."
        }
      },
      accessLanguageTerms: "Greifen Sie auf die {{category}}-Sprachbegriffe in Liquid mit {{code}} zu",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Titel",
        description: "Beschreibung",
        heading: "Überschrift",
        subheading: "Unterüberschrift",
        button_text: "Button-Text",
        link_text: "Link-Text",
        placeholder: "Platzhalter",
        label: "Bezeichnung",
        help_text: "Hilfetext",
        error_message: "Fehlermeldung",
        success_message: "Erfolgsmeldung",
        
        // Opening hours
        Monday: "Montag",
        Tuesday: "Dienstag",
        Wednesday: "Mittwoch",
        Thursday: "Donnerstag",
        Friday: "Freitag",
        Saturday: "Samstag",
        Sunday: "Sonntag",
        opening_hours_format: "Öffnungszeiten-Format",
        closes_at_format: "Schließt um Format",
        opens_at_format: "Öffnet um Format",
        opens_on: "Öffnet am",
        open_24h: "24h geöffnet",
        open: "Geöffnet",
        closed: "Geschlossen",
        closes_at: "Schließt um",
        opens_at: "Öffnet um",
        
        // Map
        search_map: "Karte durchsuchen",
        search_area: "Diesen Bereich durchsuchen",
        view_map: "Karte",
        view_list: "Liste",
        open_filters: "Filter",
        stores_near_you: "Geschäfte in Ihrer Nähe",
        header: "Finden Sie ein Geschäft!",
        search_placeholder: "Geben Sie eine Postleitzahl oder Adresse ein...",
        no_listings: "Es tut uns leid, wir können keine Standorte für Ihre Suche finden. Versuchen Sie, die Filter oder den Suchstandort zu ändern",
        
        // Directory
        view_directory: "Geschäftsverzeichnis",
        
        // Location
        get_directions: "Wegbeschreibung",
        call: "Anrufen",
        view_website: "Website",
        email: "E-Mail",
        opening_hours_header: "Öffnungszeiten",
        description_header: "Informationen",
        phone_number_header: "Telefon",
        address_header: "Adresse",
        tag_groups_to_display: "Anzuzeigende Tag-Gruppen"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Allgemein",
        navigation: "Navigation",
        forms: "Formulare",
        buttons: "Buttons",
        messages: "Nachrichten",
        errors: "Fehler",
        opening_hours: "Öffnungszeiten",
        map: "Karte",
        directory: "Verzeichnis",
        location: "Standort"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Theme erfolgreich gespeichert",
        saveError: "Theme konnte nicht gespeichert werden"
      },
      accessSettings: "Greifen Sie auf die {{category}}-Einstellungen in Liquid mit {{code}} zu",
      fields: {
        // Colors
        color_text: "Textfarbe",
        color_text_heading: "Überschrift-Textfarbe", 
        color_background: "Hintergrundfarbe",
        color_accent: "Akzentfarbe",
        color_text_positive: "Positiver Textfarbe",
        color_text_negative: "Negativer Textfarbe",
        dark_theme: "Dunkles Theme",
        color_marker: "Markerfarbe",
        color_search_marker: "Suchmarkerfarbe",
        
        // Typography
        base_font_size: "Basis-Schriftgröße",
        
        // Buttons
        border_radius: "Rahmenradius",
        
        // Images
        aspect_ratio: "Seitenverhältnis",
        fit: "Anpassung",
        
        // Spacing
        page_width: "Seitenbreite",
        page_width_small: "Kleine Seitenbreite",
        gutter_desktop: "Desktop-Rinne",
        gutter_mobile: "Mobile-Rinne",
        desktop_vertical_spacing: "Desktop-vertikaler Abstand",
        mobile_vertical_spacing: "Mobile-vertikaler Abstand",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Bei Bewegung suchen",
        scroll_to_zoom: "Scroll zum Zoomen",
        
        // Landing page
        sidebar_width: "Sidebar-Breite",
        sidebar_min_height: "Sidebar-Mindesthöhe",
        marker_image_src: "Marker-Bildquelle",
        show_filter_descriptions: "Filterbeschreibungen anzeigen",
        
        // Location page
        tag_groups_to_display: "Anzuzeigende Tag-Gruppen",
        tag_groups_to_display_as_icons: "Als Icons anzuzeigende Tag-Gruppen",
        show_related_locations: "Verwandte Standorte anzeigen",
        
        // Locations
        hide_regions: "Regionen ausblenden"
      },
      categories: {
        colors: "Farben",
        typography: "Typografie",
        buttons: "Buttons",
        images: "Bilder",
        spacing: "Abstände",
        breakpoints: "Breakpoints",
        map: "Karte",
        landing_page: "Landing Page",
        location_page: "Standortseite",
        locations: "Standorte"
      }
    },
    navigation: {
      sublimeTheme: "Sublime Theme",
      settings: "Einstellungen",
      language: "Sprache",
      templates: "Vorlagen",
      changeTheme: "Theme ändern",
      viewDirectory: "Verzeichnis anzeigen",
      viewLandingPage: "Landing Page anzeigen"
    },
    card: {
      lastUpdated: "Zuletzt aktualisiert",
      view: "Anzeigen",
      customize: "Anpassen",
      publish: "Veröffentlichen",
      actions: "Aktionen"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytics",
    timePeriods: {
      last7days: "Letzte 7 Tage",
      last30days: "Letzte 30 Tage"
    },
    comparison: {
      compareToPrevious: "Mit vorherigem Zeitraum vergleichen",
      stopComparing: "Vergleich mit vorherigem Zeitraum beenden"
    },
    sections: {
      searchLocations: "Standorte durchsuchen"
    },
    cards: {
      sessions: "Sitzungen",
      topSearches: "Top-Suchen",
      topLandingPageType: "Top-Landing-Page-Typ",
      topPageViewsBySession: "Top-Seitenaufrufe nach Sitzung",
      topLocations: "Top-Standorte",
      topReferrers: "Top-Referrer",
      searches: "Suchen",
      topLandingPagesBySession: "Top-Landing-Pages nach Sitzung"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 